/* CHYRONYX — Scroll to Top button (replaces ScrollToTop.tsx) */
(function(){
  var btn = document.querySelector('.scroll-top-btn');
  if (!btn) return;
  window.addEventListener('scroll', function(){
    if (window.scrollY > 400) btn.classList.add('scroll-top-visible');
    else btn.classList.remove('scroll-top-visible');
  }, {passive:true});
  btn.addEventListener('click', function(){
    window.scrollTo({top:0, behavior:'smooth'});
  });
})();
